import API from '../dataApi';

// -- Co-Admins -----------------------------------------------------------------
export const getCoAdmins = (derasarId) => API.get('/co-admins', { params: { derasarId } });
export const inviteCoAdmin = (data) => API.post('/co-admins/invite', data);
export const updateCoAdminPermissions = (membershipId, data) =>
  API.put(`/co-admins/${membershipId}/permissions`, data);
export const revokeCoAdmin = (membershipId, derasarId) =>
  API.delete(`/co-admins/${membershipId}`, { params: { derasarId } });
export const revokeInvite = (inviteId, derasarId) =>
  API.delete(`/co-admins/invites/${inviteId}`, { params: { derasarId } });
export const resendInvite = (inviteId, data) =>
  API.post(`/co-admins/invites/${inviteId}/resend`, data);
